import React from 'react';
import c from './index.module.scss'
import { ReactComponent as Logo } from "assets/images/logo.svg";
import { ReactComponent as ExternalLink } from 'assets/images/telegram.svg';

import {useTranslation} from "react-i18next";
import Links from "components/Links";
import Button from "components/Button";

const NavBar = ({botLink}) => {
    const { t } = useTranslation();

    const handleOpenBot = () => {
        window.open(
            `tg://resolve?domain=${botLink}`,
            "_blank"
        );
    }

    return (
        <div className={c.nav_bar}>
                <Logo className='logo' />
            <div className={c.links}>
                <Links />
            </div>
                <Button Icon={ExternalLink} text={t('default.buttonText')} onClick={handleOpenBot} />
        </div>
    );
};

export default NavBar;